import { useState } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import WelcomeScreen from "./components/WelcomeScreen";
import NetworkSelection from "./components/NetworkSelection";
import PasswordSetup from "./components/PasswordSetup";
import DisplayRecoveryPhrase from "./components/DisplayRecoveryPhrase";
import ImportOptions from "./components/ImportOptions";
import RecoveryPhraseImport from "./components/RecoveryPhraseImport";
import PrivateKeyImport from "./components/PrivateKeyImport";
import "./styles/global.css";

export default function App() {
  const [appState, setAppState] = useState({
    isCreatingNew: true,
    selectedNetwork: "",
    password: "",
    recoveryPhrase: [],
  });

  const updateState = (updates) => {
    setAppState((prev) => ({ ...prev, ...updates }));
  };

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<WelcomeScreen appState={appState} updateState={updateState} />} />
          <Route path="/network-selection" element={<NetworkSelection appState={appState} updateState={updateState} />} />
          <Route path="/password-setup" element={<PasswordSetup appState={appState} updateState={updateState} />} />
          <Route path="/display-recovery-phrase" element={<DisplayRecoveryPhrase appState={appState} updateState={updateState} />} />
          <Route path="/import-options" element={<ImportOptions appState={appState} updateState={updateState} />} />
          <Route path="/recovery-phrase-import" element={<RecoveryPhraseImport appState={appState} updateState={updateState} />} />
          <Route path="/private-key-import" element={<PrivateKeyImport appState={appState} updateState={updateState} />} />
        </Routes>
      </div>
    </Router>
  );
}
